import React, { useEffect, useState } from "react";
import { FormHead, Buttons, FormsControl } from "./";
import style from "./profile.module.scss";
import ProfileService from "../../../service/profile";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

function ContactDetails(props) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const [state, setState] = useState({ customFields: [] });
  const [data, setData] = useState(props.data);
  const [cityOptions, setCityOptions] = useState([]);
  const service = new ProfileService();
  const history = useHistory();

  useEffect(() => {
    if (data.find((object) => object.code === "country")) {
      const selectedCountry = data.find(
        (object) => object.code === "country"
      ).value;
      getProvinceOptions(selectedCountry);
    }
  }, []);

  const getProvinceOptions = (selectedCountry) => {
    service.getProvince(selectedCountry).then((res) => {
      if (res.status) {
        setData((prevData) =>
          prevData.map((object) => {
            if (object.code === "province") {
              return {
                ...object,
                options: res.data,
              };
            }
            return object;
          })
        );
      } else {
        // Handle error
      }
    });
  };

  const changeHandler = (e, isReq) => {
    const { name, value } = e.target;
    setData((prevData) =>
      prevData.map((object) => {
        if (object.code === name) {
          // Validation code goes here
          return {
            ...object,
            value: value,
            error: value.length === 0 && isReq ? "validation.required" : "",
            errorField: {
              field: name,
            },
          };
        }
        return object;
      })
    );
  };

  const changeDropDown = (key, id) => {
    if (id.code === "country") {
      setData((prevData) =>
        prevData.map((object) => {
          if (object.code === "country") {
            return {
              ...object,
              value: key,
            };
          }
          return object;
        })
      );
      getProvinceOptions(key);
    } else if (id.code === "province") {
      setData((prevData) =>
        prevData.map((object) => {
          if (object.code === "province") {
            return {
              ...object,
              value: key,
            };
          }
          return object;
        })
      );
      getCityOptions(key);
    } else if (id.code === "city") {
      setData((prevData) =>
        prevData.map((object) => {
          if (object.code === id.code) {
            return {
              ...object,
              value: key,
            };
          }
          return object;
        })
      );
      getBarangayOptions(key);
    } else {
      setData((prevData) =>
        prevData.map((object) => {
          if (object.code === id.code) {
            return {
              ...object,
              value: key,
            };
          }
          return object;
        })
      );
    }
  };

  const getCityOptions = (selectedProvince) => {
    service.getCity(selectedProvince).then((res) => {
      if (res.status) {
        setCityOptions(res.data);
        setData((prevData) =>
          prevData.map((object) => {
            if (object.code === "city") {
              return {
                ...object,
                options: res.data,
              };
            }
            return object;
          })
        );
      } else {
        // Handle error
      }
    });
  };

  const getBarangayOptions = (selectedCity) => {
    service.getBarangay(selectedCity).then((res) => {
      if (res.status) {
        setData((prevData) =>
          prevData.map((object) => {
            if (object.code === "barangay") {
              return {
                ...object,
                options: res.data,
              };
            }
            return object;
          })
        );
      } else {
        // Handle error
      }
    });
  };

  //click the cancel button click
  const cancelButtonClick = () => {
    setData(props.data);
    props.cancelbtn();
  };

  const onSubmit = () => {
    let error = false;
    let formdata = {};
    data.forEach((element) => {
      if (element.error) {
        error = true;
      }
      if (element.required && !element.value) {
        element.error = "validation.required";
        element.errorField = {
          field: element.code,
        };
      } else if (element.custom) {
        // setState((prev) => ({
        //   ...prev,
        //   customFields: state.customFields.push({[element.field_name]: element.value ?? ""}),
        // }));
        state.customFields.push({
          id: element.id,
          value: element.value ?? "",
        });
        formdata = {
          ...formdata,
          customFields: state.customFields,
        };
      } else {
        if (element.value === "NA") {
          formdata = {
            ...formdata,
            [element.field_name]: "",
          };
        } else {
          formdata = {
            ...formdata,
            [element.field_name]: element.value ?? "",
          };
        }
      }
    });
    if (!error) {
      service.UpdateContactDetails(formdata).then((res) => {
        if (res.status) {
          props.showNotify("success", "success", "profile." + res.data.message);
          props.cancelbtn();
          props.updateSuccess(data, props.stateKey);
          // props.getData();
        } else {
          if (res.error.code === 1004) {
            Object.keys(res.error.fields).map((key) => {
              setData(
                [...data].map((object) => {
                  if (object.field_name === key) {
                    if (key == "email") {
                      return {
                        ...object,
                        error: "validation.invalidEmail",
                        errorField: {
                          field: key,
                        },
                      };
                    }
                    if (key == "mobile") {
                      return {
                        ...object,
                        error: "validation.invalid",
                        errorField: {
                          field: "phoneNumber",
                        },
                      };
                    }
                    return {
                      ...object,
                      error: "validation." + res.error.fields[key],
                      errorField: {
                        field: key,
                      },
                    };
                  } else return object;
                })
              );
              return null;
            });
            props.showNotify(
              "danger",
              "error",
              "validation.checkValueYouHaveSubmitted"
            );
          } else if (res.error.code === 1002) {
            history.push("/logout");
          }
        }
      });
    } else {
      setData(data);
      props.showNotify(
        "danger",
        "error",
        "validation.checkValueYouHaveSubmitted"
      );
    }
  };
  return (
    <div
      className={`${
        currentTheme == "theme-dark"
          ? `${style.dark_mode_ContactDetails}`
          : `${style.ContactDetails}`
      }`}
    >
      <FormHead
        uploadData={props.uploadedData}
        title="contactDetails"
        change={props.change}
        status={props.status}
        // show={props.isEditable}
        show={props.primary === false ? false : props.detailsDisable}
        detailsDisable={props.primary === false ? true : props.detailsDisable }
      />
      <div className={style.ContactDetailsForms}>
        {data.map((forms, index) => {
          console.log("contact details data", forms);
          return (
            <FormsControl
              uploadedData={props.uploadedData} // Pass the uploadedData state as a prop
              key={index}
              change={changeHandler}
              status={props.isEditable}
              data={forms}
              dropdownChange={changeDropDown}
            />
          );
        })}
      </div>

      {!props.isEditable && (
        <Buttons cancel={cancelButtonClick} submitHandler={onSubmit} />
      )}
    </div>
  );
}

export default ContactDetails;
